var map = {
	"./AUD.svg": "./static/images/currency/AUD.svg?104a",
	"./CAD.svg": "./static/images/currency/CAD.svg",
	"./CNH.svg": "./static/images/currency/CNH.svg",
	"./EUR.svg": "./static/images/currency/EUR.svg",
	"./GBP.svg": "./static/images/currency/GBP.svg",
	"./HKD.svg": "./static/images/currency/HKD.svg?4907",
	"./IDR.svg": "./static/images/currency/IDR.svg",
	"./JPY.svg": "./static/images/currency/JPY.svg",
	"./MYR.svg": "./static/images/currency/MYR.svg",
	"./NZD.svg": "./static/images/currency/NZD.svg?24c8",
	"./SGD.svg": "./static/images/currency/SGD.svg?16f0",
	"./THB.svg": "./static/images/currency/THB.svg",
	"./USD.svg": "./static/images/currency/USD.svg?fa56",
	"./VND.svg": "./static/images/currency/VND.svg",
	"./other-bank.svg": "./static/images/currency/other-bank.svg?85f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./static/images/currency sync \\.\\/.*\\.(svg%7Cpng%7Cjpg)$";